/**
 * Переключатель языка интерфейса (B1).
 *
 * Названия языков написаны на них самих: человек, ищущий свой язык, не обязан
 * знать, как он называется по-английски.
 */
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import { changeLanguage, languages } from '../../i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? 'en';

  return (
    <label className="flex items-center gap-2 text-meta text-content-secondary">
      <Languages className="h-4 w-4" strokeWidth={1.75} />
      <select
        value={current}
        onChange={(event) => void changeLanguage(event.target.value)}
        className="rounded-control border border-line bg-surface px-2 py-1 text-meta text-content focus:border-accent focus:outline-none"
      >
        {languages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.label}
          </option>
        ))}
      </select>
    </label>
  );
}
